import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Invite_User } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import InviteUsersForm from './InviteUsersForm';
import Validation from '../../../../../../components/Validation';
function CreateInviteUsersForm({ propertyId, userName }) {
    const [isCreating, setIsCreating] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const handleSubmit = data => {
        //console.log(data);
        const auditData = {
            content: data,
            createdBy: userName
        }
        var body = { ...data, auditData: auditData };
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Invite_User}`,
            data: body,
        })
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    };

    return (
        <div>
            <Button
                color="primary"
                outline
                size="xs"
                onClick={() => {
                    setIsCreating(!isCreating);
                }}
                className="top-right-button mr-1"
            //  style={{ width: '100%', borderRadius: '6px' }}
            >
                + Create & Invite a User
            </Button>
            <InviteUsersForm
                formLabel="Create & Invite a User"
                visible={isCreating}
                toggle={() => {
                    setIsCreating(!isCreating);
                }}
                submit={handleSubmit}
            />
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, userName } = settings;
    return {
        propertyId, userName
    };
};

export default injectIntl(connect(mapStateToProps, {})(CreateInviteUsersForm));

CreateInviteUsersForm.propTypes = {
    // propertyId: PropTypes.string.isRequired,
};
